import { type WalletClient, type TransactionRequest, encodeFunctionData, erc20Abi, type Address } from "viem";
import { estimateContractTransactionGas } from "@/utils";

// Helper function to prepare a token approval transaction
export const prepareTokenApprovalTransaction = (
    tokenAddress: Address,
    spenderAddress: Address,
    amount: bigint,
): TransactionRequest => {
    return {
        to: tokenAddress,
        data: encodeFunctionData({
            abi: erc20Abi,
            functionName: "approve",
            args: [spenderAddress, amount],
        }),
    };
};

// Helper function to estimate gas for token approval
export const estimateTokenApprovalGas = async (
    walletClient: WalletClient,
    tokenAddress: Address,
    spenderAddress: Address,
    amount: bigint,
): Promise<bigint> => {
    const approvalTx = prepareTokenApprovalTransaction(tokenAddress, spenderAddress, amount);
    return estimateContractTransactionGas(walletClient, approvalTx);
};
